import { render } from "./AuthPaymentStatusTracker.vue?vue&type=template&id=36718a8f&scoped=true"
import script from "./AuthPaymentStatusTracker.vue?vue&type=script&lang=js"
export * from "./AuthPaymentStatusTracker.vue?vue&type=script&lang=js"

import "./AuthPaymentStatusTracker.vue?vue&type=style&index=0&id=36718a8f&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36718a8f"]])

export default __exports__